import script from "./PhoneMyVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMyVideos.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMyVideos.vue?vue&type=style&index=0&id=327870a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-327870a0"]])

export default __exports__